import axiosVerbose from './axios/axiosVerbose'
import { logError } from './errors'

export const getItemMatrix = itemId => {
  return axiosVerbose
    .get(`/shopfront-api/item/${itemId}/price_matrix`)
    .then(res => res.data)
    .catch(err => Promise.reject(logError(err)))
}
